import { Helmet } from "react-helmet-async";

/**
 * Geographic meta tags for city landing pages.
 * Uses Helmet so tags are auto-removed when the page unmounts (SPA-safe).
 */
export default function GeoMeta({ city, state, lat, lon }) {
  if (!city || lat == null || lon == null) return null;
  return (
    <Helmet>
      <meta name="geo.region" content={state ? `US-${state}` : "US"} />
      <meta name="geo.placename" content={state ? `${city}, ${state}` : city} />
      <meta name="geo.position" content={`${lat};${lon}`} />
      <meta name="ICBM" content={`${lat}, ${lon}`} />
    </Helmet>
  );
}
